// btw-front/src/api/adminStats.js
import { api } from "./client";

// 관리자 대시보드 [통계] 탭 — 전사 요약 집계
// 응답: { deals: {total, inProgress, adoption, lost, poTotal, byStage:[{status,value}]},
//         partners: {total, active}, signups: {pending, approved, rejected} }
export async function get() {
  return api.get("/admin/stats");
}
